import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPointer"><Path d="M12.0303 8.66667H17.6364C19.494 8.66667 21 10.1591 21 12V14.0325C21 18.4328 17.4004 22 12.96 22C9.97497 22 7.23562 20.3611 5.84534 17.7433L2.5 11.4444L3.34159 10.4019C4.11525 9.44357 5.52639 9.28819 6.49346 10.0549L7.54545 10.8889V4.22222C7.54545 2.99492 8.54942 2 9.78788 2C11.0263 2 12.0303 2.99492 12.0303 4.22222V8.66667Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPointer;
